module.exports = __webpack_public_path__ + "img/fratelli-site-web.4218923.jpg";